import activities from './activities.json';
import employees from './employees.json';
const profile = {
   'profile-activities': activities,
   'profile-employees': employees,
};
export default profile;
